<template>
    <div class="box">
        <img class="bg" src="../../assets/img/womensDay/bg1.png" alt="">
        <!-- 端外 -->
        <audio id="audio" :src="url"></audio>
        <audio style="position:absolute;left:0;top:0;z-index:10000;" src="http://img001.seefm.com.cn/video/www/music_wy_8.mp3"></audio>
        <div class="main" v-if="appShow == 1">
            <div class="box1">
                <div class="header">
                    <img :src='hostAvatar' alt="">
                    <div class="nameBox">
                        <p class="hostName">{{hostName}}</p>
                        <p class="stationName">{{stationName}}</p>
                    </div>
                   
                </div>
                <div class="btm">
                    <img class="audioIcon" v-show="isPlay==0" src="../../assets/img/womensDay/audioIcon.png" alt="">
                    <div class="audioIcon" id="demoCanvas" v-show="isPlay==1" alt="" srcset=""></div>
                    <img class="play" v-show="isPlay==0" @click="play()" src="../../assets/img/womensDay/play.png" alt="">
                     <img class="play" v-show="isPlay==1" @click="pause()" src="../../assets/img/womensDay/stop2.png" alt="">
                    <div class="time">{{time}}</div>
                </div>
            </div>
            <div @click="toHome()" class="right">查看更多语音祝福<span>  <img src="../../assets/img/womensDay/right.png" alt=""></span></div>
            <!-- <img class="goPoster" v-if="from1=='app'" @click="toPoster()" src="../../assets/img/womensDay/share.png" alt=""> -->
            <img class="goPoster" @click="toPoster()" src="../../assets/img/womensDay/goshare.png" alt="">
        </div>
        <!-- 端内 -->
        <div class="main1" v-if="appShow == 0">
            <div class="box1">
                <div class="header">
                    <img :src='hostAvatar' alt="">
                    <div class="nameBox">
                        <p class="hostName">{{hostName}}</p>
                        <p class="stationName">{{stationName}}</p>
                    </div>
                    <span class="shareNum">{{number}}人分享</span>
                </div>
                <div class="content">{{content}}</div>
                <div class="btm">
                    <img class="detailsBg"  v-show="isPlay==0" src="../../assets/img/womensDay/detailsBg.png" alt="">
                    <div class="detailsBg" id="demoCanvas1" v-if="isPlay==1" alt="" srcset=""></div>
                    <img class="play" v-show="isPlay==0" @click="play()" src="../../assets/img/womensDay/play1.png" alt="">
                     <img class="play" v-show="isPlay==1" @click="pause()" src="../../assets/img/womensDay/stop.png" alt="">
                    <div class="time">{{time}}</div>
                </div>
            </div>
            <img class="goPoster" @click="toPoster()" src="../../assets/img/womensDay/goshare.png" alt="">
        </div>
    </div>
</template>
<script>
import { Toast } from 'mint-ui';
import "mint-ui/lib/style.css" 
import cbct from '../../assets/js/common/base.js';
import axios from 'axios';
import qs from 'qs';
import share from '../../assets/js/common/share.js';
import shareMsg from '../../assets/js/common/shareConfig.js';
import SVGA from 'svgaplayerweb';
export default {
    name: 'womensDayDetails',
   
    data:function(){
        return{
            from1:'',
            //电台名称
            stationName:'',
            //主持人名称
            hostName:'',
            //主持人头像
            hostAvatar:'',
            //文案
            content:'',
            number:'',
            url:'',
            time:'',
            //是否播放
            isPlay:'0',
            appShow:'1',
            isShare:'',
            did:'',
            isToken:'',
            isSalt:'',
        }
    },
    components:{
      
    },
    created(){
        var self =this;
        if(this.$route.query.from1){
            this.from1 = this.$route.query.from1;
        }
        if(this.$route.query.videoId){
            this.videoId = this.$route.query.videoId;
        }
        if(this.$route.query.isShare){
            this.appShow = this.$route.query.isShare;
        }else{
            this.appShow =0;
        }
         $('title').html('祝福分享');
        if(this.from1 == 'app'){
            window['onWebResponse']=(str)=>{
                self.onWebResponse(str)
            }
            this.getTitle();
        }
      axios.defaults.headers = {
          'Content-Type':'application/x-www-form-urlencoded',
      };
     this.api2.post(this.cbct.https()+'/admin/time', {  
        })
        .then(function (response) {
            if(response.c == self.cbct.code.successRes){
                var timing = response.d.time - Date.parse(new Date()); 
                 self.cbct.setCookie('timing',timing);
                    self.getDate();
                    // self.getPv('20203');
                } 
        })
        .catch(function (error) {});  
    },
    mounted(){
        var self=this;
        this.isToken = self.cbct.getCookie('token2');
        this.isSalt = self.cbct.getCookie('salt2');
        // 播放完自动关闭动画
        var audio = document.getElementById("audio"); 
        audio.loop = false;
        audio.addEventListener('ended', function () {  
            self.isPlay=0;
        }, false);
      
            // shareMsg.shareConfig(
            //     this.from1,'0','0','贺新春，领红包','恭喜收到，听见广播新年现金红包','http://'+src+'iandwe.com.cn/lachineIndex','https://seefm.oss-cn-beijing.aliyuncs.com/image/recive_hong_bao.jpg','','0'
            // )
            // var shareUrl ='http://channels.h5.'+src+'cbct.cn/womensDayDetails?videoId='+this.videoId+'&isShare=1';
            // share.share(shareUrl,'听见最美的声音，做最有魅力的女神','来自'+this.hostName+'主持人的一段真挚祝福','http://img001.seefm.com.cn/image/activity38_1.jpg');
            // share.QQshare(shareUrl,'听见最美的声音，做最有魅力的女神','来自'+this.hostName+'主持人的一段真挚祝福','http://img001.seefm.com.cn/image/activity38_1.jpg');
    },
   
    methods:{
        SVGA:function(msg){
            var self = this;
            var player = new SVGA.Player('#demoCanvas');
            var parser = new SVGA.Parser('#demoCanvas'); // Must Provide same selector eg:#demoCanvas IF support IE6+
            parser.load('https://seefm.oss-cn-beijing.aliyuncs.com/audio/detail_red.svga',function(videoItem){
                player.setVideoItem(videoItem);
                player.startAnimation();
            })
        },
        SVGA1:function(msg){
            var self = this;
            var player1 = new SVGA.Player('#demoCanvas1');
            var parser1 = new SVGA.Parser('#demoCanvas1'); // Must Provide same selector eg:#demoCanvas IF support IE6+
            parser1.load('https://seefm.oss-cn-beijing.aliyuncs.com/audio/detail.svga',function(videoItem){
                player1.setVideoItem(videoItem);
                player1.startAnimation();
            })
        },
        //去首页
        toHome:function(id){
            if(this.from1 == 'app'){
                this.$router.push({path:'./womensDayIndex?from1=app'});
            }else{
                this.$router.push({path:'./womensDayIndex'});
            }
        },
        //去海报页
         toPoster:function(id){
             var self = this;
                if(self.cbct.getCookie('token2') == 'TOKEN' || self.cbct.getCookie('token2') == ''){    
                    self.gotoLoginPage();
                    
                }else{
                    if(this.from1 == 'app'){
                        this.$router.push({path:'./womensDayPoster?from1=app'+'&stationName='+this.stationName+'&hostName='+this.hostName+'&videoId='+this.videoId});
                    }else{
                        this.$router.push({path:'./womensDayPoster?stationName='+this.stationName+'&hostName='+this.hostName+'&videoId='+this.videoId});
                    }
                }
               
            
           
        },
        play(){
            var self = this;
            let audio = document.getElementById('audio');

            this.isPlay=1;
            setTimeout(()=>{
                audio.play();
                if(self.appShow==1){
                    self.SVGA();
                }else{
                    self.SVGA1();
                } 
                       
            });
           
        },
        pause(){
            let audio = document.getElementById('audio');
            this.isPlay=0;
            audio.pause();
        },
          //登录处理
        gotoLoginPage:function(){
                var self=this;
                var u = navigator.userAgent, app = navigator.appVersion;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (self.from1 == 'app') {
                        const win = window;
                        var obj={
                            "action": "goToLogin",
                            "content": {
                                'isReturnHomepage':'0'
                            }
                        }
                        if (isAndroid) {
                            App.onAppResponse(JSON.stringify(obj));

                        }
                        if (isIOS) {
                            win.webkit.messageHandlers.onAppResponse.postMessage(JSON.stringify(obj));
                        }  
                }else{
                    this.$router.push({path:'./womensDayLogin?&videoId='+this.videoId});
                }
            },
          // 嵌入app获取用户登陆状态
              // 嵌入app获取用户登陆状态
        onWebResponse:function(str) {
            var obj=JSON.parse(str);
            var action=obj.action;
            var self=this;
            var content=obj.content;
            if (action=='setUserInfo') {
                self.did=content.did;
                self.isToken=content.token;
                self.isSalt=content.salt;
                if (self.isToken=='') {
                    self.cbct.setCookie('token2','TOKEN'); 
                }else{
                    self.cbct.setCookie('token2',self.isToken);
                }
                if (self.isSalt=='') {
                    self.cbct.setCookie('salt2','SALT'); 
                }else{
                    self.cbct.setCookie('salt2',self.isSalt);
                }
                if(self.did==''){
                   self.cbct.setCookie('did',self.did);
                }
            }
        },
        //给安卓传title的方法
        getTitle:function(){
            var self=this;
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            var obj={
                    "action": "setTitle",
                    "content": {
                        'title':'祝福分享',
                    }
                }
                if (isAndroid){
                    App.onAppResponse(JSON.stringify(obj));
                }
        },
      
         // 获取数据
        getDate:function(id){
            let self = this;
            this.api2.get(this.cbct.https()+'/h5/activity/womendays/info?id='+ this.videoId).then((response)=>{
                if(response.c == this.cbct.code.successRes){ 
                    this.hostName= response.d.name;
                    var src = this.cbct.https().split('channels-')[1].split('.')[0];
                    if(src != ''&& src != undefined){
                        if(src != 'dev' && src != 'test'){
                            src = '';
                        }else{
                            src = src+'.';
                        }
                    }
                    var shareUrl ='http://channels.h5.'+src+'cbct.cn/womensDayDetails?videoId='+this.videoId+'&isShare=1';
                    share.share(shareUrl,'听见最美的声音，做最有魅力的女神','来自'+this.hostName+'主持人的一段真挚祝福','http://img001.seefm.com.cn/image/activity38_1.jpg');
                    share.QQshare(shareUrl,'听见最美的声音，做最有魅力的女神','来自'+this.hostName+'主持人的一段真挚祝福','http://img001.seefm.com.cn/image/activity38_1.jpg');
                    this.hostAvatar=self.cbct.imgUrl()+ response.d.avatar;
                    this.stationName= response.d.title;
                    this.content = response.d.content;
                    this.number = response.d.use_count;
                    this.url = response.d.voice;
                    $('audio').src =  response.d.voice;
                     if(response.d.voice_duration<60){
                            this.time = "00:"+ response.d.voice_duration;
                        }else{
                           this.time = parseInt(response.d.voice_duration/60)+":"+parseInt(response.d.voice_duration%60);
                        }
                    // this.$nextTick(function(){
                    //    self.initSwiper()
                    // })
                }else if(response.c == this.cbct.code.noLogin){
                    Toast({
                        message:response.m ,
                        position: 'center',
                        duration: 1000
                    });
                    timing.time();
                }else if(response.c == this.cbct.code.raleNoLogin){
                    //  self.$router.replace({path:'./fissionLogin'});
                }else{
                    Toast({
                        message:response.m,
                        position: 'center',
                        duration: 1000   
                    });
                   
                }
            }
            ).catch((error)=>{console.log(error);})
        },
       
    },

    filters:{
     
    },
    destroyed: function () {
      
    }
    
}
</script>
<style scoped lang="scss">
    .box{
        width: 100%;
        min-height: 100vh;
        height: auto;
        background: #FFAEAC;
        position: relative;
        overflow: hidden; 
        .bg{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height:auto;
            z-index: 1;
        }
        .main{
            position: absolute;
            top: 3.98rem;
            left: 0;
            width: 100%;
            z-index: 33;
            .box1{
                margin: 0 auto;
                width: 6.72rem;
                height:4.65rem ;
                border-radius: .55rem;
                overflow: hidden;
                background: #fff;
                box-sizing: border-box;
                z-index: 2;
                .header{
                    width: 100%;
                    height:.92rem;
                    box-sizing: border-box;
                    overflow: hidden;
                    text-align: left;
                    img{
                        float: left;
                        width:.6rem;
                        height: .6rem;
                        border-radius: 50%;
                        overflow: hidden;
                        margin: .22rem .2rem 0 .25rem;
                    }
                    .nameBox{
                        float: left;
                        .hostName{
                            font-size: .26rem;
                            color: rgba(0, 0, 0, .8);
                            margin-top: .2rem;
                            line-height: .36rem;
                        }
                        .stationName{
                            font-size: .2rem;
                            color: rgba(32, 14, 14, 0.39);
                            line-height: .28rem;
                        }
                    }
                }
                .btm{
                    width: 6.72rem;
                    height:3.76rem;
                    box-sizing: border-box;
                    position: relative;
                    overflow: hidden;
                    background:#FF6372 ;
                    .audioIcon{
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }
                    .play{
                        width: .66rem;
                        height: .66rem;
                        position: absolute;
                        left:.25rem;
                        bottom: .23rem;
                    }
                    .time{
                        position: absolute;
                        right:.3rem;
                        bottom: .23rem;
                        font-size: .33rem;
                        line-height: 1;
                        color: rgba(255, 255, 255, 0.7);
                    }
                }
            }
            .right{
                text-align: right;
                font-size: .3rem;
                color: #fff;
                height: .44rem;
                line-height: .44rem;
                margin:.1rem .44rem 0 0 ;
                span{
                    display: inline-block;
                    width: .44rem;
                    height: .44rem;
                    float:right;
                    margin-left:.16rem ;
                    img{
                        width: 100%;
                    }
                }
            }
            .goPoster{
              width: 4.75rem;
              margin: .68rem auto 0;  
            }
        }
        .main1{
            position: absolute;
            top: 3.98rem;
            left: 0;
            width: 100%;
            z-index: 33;
            .box1{
                margin: 0 auto;
                width: 6.72rem;
                height:auto ;
                border-radius: .55rem;
                overflow: hidden;
                background: #fff;
                box-sizing: border-box;
                z-index: 2;
                .header{
                    width: 100%;
                    height:.92rem;
                    box-sizing: border-box;
                    overflow: hidden;
                    text-align: left;
                    img{
                        float: left;
                        width:.6rem;
                        height: .6rem;
                        border-radius: 50%;
                        overflow: hidden;
                        margin: .22rem .2rem 0 .25rem;
                    }
                    .nameBox{
                        float: left;
                        .hostName{
                            font-size: .26rem;
                            color: rgba(0, 0, 0, .8);
                            margin-top: .2rem;
                            line-height: .36rem;
                        }
                        .stationName{
                            font-size: .2rem;
                            color: rgba(32, 14, 14, 0.39);
                            line-height: .28rem;
                        }
                    }
                    .shareNum{
                        height: auto;
                        line-height: 1;
                        padding: 0.11rem .19rem;
                        float: right;
                        background:rgba(255, 35, 35, .19) ;
                        font-size: .22rem;                      
                        color: #C43434;
                        border-radius: .22rem;
                        margin: .33rem .25rem 0 0;
                        display: inline-block;
                        justify-content: center;
                    }
                }
                .content{
                   width: 6.05rem;
                   text-align: left;
                   margin: 0 auto .19rem;
                   font-size: .3rem;
                   color: rgba(0, 0, 0, .8); 
                   line-height: .42rem;
                   border-top: .01rem solid rgba(0, 0, 0, .1);
                   padding-top: .19rem;
                }
                .btm{
                    width: 6.4rem;
                    height:1.04rem;
                    box-sizing: border-box;
                    margin: 0 auto .16rem;
                    position: relative;
                    .detailsBg{
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }
                    .play{
                        width: .66rem;
                        height: .66rem;
                        position: absolute;
                        left:.19rem;
                        bottom: .19rem;
                    }
                    .time{
                        line-height: 1;
                        position: absolute;
                        right:.27rem;
                        bottom: .35rem;
                        font-size: .33rem;
                        color: rgba(126, 91, 251, 1);
                    }
                }
            }
            .right{
                text-align: right;
                font-size: .3rem;
                color: #fff;
                height: .44rem;
                line-height: .44rem;
                margin:.1rem .44rem 0 0 ;
                span{
                    display: inline-block;
                    width: .44rem;
                    height: .44rem;
                    float:right;
                    margin-left:.16rem ;
                    img{
                        width: 100%;
                    }
                }
            }
            .goPoster{
              width: 4.75rem;
              margin: .68rem auto 0;  
            }
        }
    }
</style>
